import styled from '@emotion/styled';
import UDInput from '../../../ud-form/components/input/component';

const BorderedInput = styled(UDInput)`
  border: 1px solid #F4F4F5;
`;

export default BorderedInput;
